<template>
  <div>
    <user-bar></user-bar>
    <landing></landing>
    <specialty></specialty>
    <div style="background-color: #FFFFFF">
      <card-carousel
        style="background-color: #011E4A"
        v-if="$vuetify.breakpoint.mdAndUp ? true : false"
      ></card-carousel>
      <customers></customers>
    </div>
    <partners></partners>
    <testimony></testimony>
    <contactUs></contactUs>
    <rooter></rooter>
  </div>
</template>

<script>
import userBar from 'Components/UserBar';
import Landing from 'Components/landing/Landing';
import Specialty from 'Components/landing/Specialty';
import Customers from 'Components/landing/Customers';
import Partners from 'Components/landing/Partners';
import Testimony from 'Components/landing/Testimony';
import ContactUs from 'Components/ContactUs';
import Rooter from 'Components/Rooter';
import 'Public/css/global.css';
import 'Public/css/fonts.css';
import CardCarousel from '../components/CardCarousel.vue';

export default {
  name: 'App',
  data() {
    return {
      loggedIn: false,
      Cards: [
        {
          preTitle: 'Conciliação de distribuída pagamentos',
          title:
            'ArcelorMittal incluiu Blockchain no seu radar de tecnologias emergentes para indústria 4.0.',
          description:
            'Foi realizado um processo consultivo com foco no levantamento e seleção de casos de uso para elaboração de um projeto piloto fundamentado na tecnologia Blockchain. O Sistema de conciliação distribuída de pagamentos entre fornecedor e cliente pode transformar uma conciliação contábil-bancária, que relaciona um documento fiscal com a sua devida quitação, de um processo centralizado que pode durar até 24 horas para um colaborativo de aproximadamente 3 minutos, tempo de confirmação da transação na Blockchain do Ethereum.',
        },
        {
          preTitle: 'Tokenização',
          title: 'Tokenização do Real Brasileiro',
          description:
            'O BRLT é um token simétrico para o BRL com paridade de um para um. A criação do BRLT foi motivada pelo desejo de entregar para sociedade brasileira o experimento de um token digital estável, seguro e auditável e capaz de transacionar valor.',
        },
        {
          preTitle: 'Cursos e Palestras',
          title: 'Blockchain para Executivos - Uma abordagem prática.',
          description:
            'Blockchain para executivos é um curso prático para C – Levels, Diretores e Gerentes entenderem como aplicar a tecnologia na sua organização de forma a gerar valor real. ​Muito se ouve dizer sobre a tecnologia Blockchain nas reuniões de projeto porém o zeitgeist do cenário corporativo brasileiro é de pouca implementação prática. Se você possui um cargo de tomador de decisão em qualquer setor e quer entender como implementar a tecnologia blockchain para resolver problemas da sua organização junte se a nós.',
        },
      ],
    };
  },
  components: {
    userBar,
    Landing,
    CardCarousel,
    Specialty,
    Customers,
    Partners,
    Testimony,
    ContactUs,
    Rooter,
  },

  methods: {},
};
</script>

<style></style>
